// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 1000px) {\n.is-disable-scroll.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {\n        pointer-events: none !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
